import { Component, ViewChild, Pipe, PipeTransform, OnDestroy } from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import {ApiService} from '../shared/api.service';
import {AssignmentsService} from '../shared/assignments.service';
import {UserService} from '../shared/user.service';
import {StatusMap} from './assignment.model';
import {FiltersService} from './filters.service';
import {ViewService} from '../shared/view.service';
import {SlideshowService} from '../slideshow/slideshow.service';

@Pipe({name: 'status'})
export class StatusPipe implements PipeTransform {
    transform(value: string, clone: any): string {
        if( StatusMap.hasOwnProperty(value) ) {
            value = StatusMap[value];
            if( (value == 'Published' || value == 'Scheduled') && clone ) {
                value = 'Copy ' + value;
            }
        }
        return value;
    }
}
@Component({
    selector: 'assignment-list',
    templateUrl: 'assignment-list.component.html'
})
export class AssignmentsComponent implements OnDestroy{
    filterSubscription;
    heartbeatSubscription;
    title = 'All Assignments';
    service;
    subscription;
    user;
    selectedRows = [];
    canDelete = false;
    taxSlugs = [];

    @ViewChild('paginator') paginator;
    @ViewChild('table') table;

    constructor(
        private route: ActivatedRoute, 
        private assignmentService: AssignmentsService, 
        private userService: UserService, 
        private api: ApiService,
        public fs: FiltersService,
        public dialog: MatDialog,
        private vs: ViewService,
        private slideshowService: SlideshowService
    ) {
        this.title = this.route.snapshot.data.title;
        this.service = assignmentService;
        this.user = api.getProp('user');
        this.taxSlugs = Object.keys(api.getProp('taxonomies'));
        if( this.user.role == 'editor' || this.user.role == 'administrator' ) {
            this.canDelete = true;
        }
        this.filterSubscription = fs.filtersChange.subscribe(query => {
            if( this.paginator ) {
                this.paginator.firstPage();
            }
            if( this.route.snapshot.data.state == 'queue' ) {
                query = Object.assign({queue: true, user: this.user.id}, query);
            }
            if( this.route.snapshot.data.state == 'sentToEditor' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('sent_to_editor') || filter.value.includes('add_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query.filters.push({key: 'status', value: 'sent_to_editor|add_sent_to_editor', compare: '='});
                }
            }
            if( this.route.snapshot.data.state == 'synSentToEditor' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('syn_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query.filters.push({key: 'status', value: 'syn_sent_to_editor', compare: '='});
                }
            }
            if( this.route.snapshot.data.state == 'readyToRepost' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('ready_to_repost');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query.filters.push({key: 'status', value: 'ready_to_repost', compare: '='});
                }
            }
            if( this.route.snapshot.data.state == 'readyToDeleteAppleNews' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('ready_to_delete_an');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query.filters.push({key: 'status', value: 'ready_to_delete_an', compare: '='});
                }
            }
            if( this.route.snapshot.data.state == 'assigned' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('assigned');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query.filters.push({key: 'status', value: 'assigned', compare: '='});
                }
            }
            this.assignmentService.userQuery = 0;
            const userId = <any>this.route.snapshot.queryParamMap.get('user');
            if( userId ) {
                this.assignmentService.userQuery = userId;
            }
            this.assignmentService.loadAssignments(query);
        });
        this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
            this.service.refresh();
        });
        this.assignmentService.deleted.subscribe(data => {
            this.table.renderRows();
            this.selectedRows = [];
            this.assignmentService.refresh();
        });
    }
    getQueryObject(queryParams: ParamMap): any {
        const keys = queryParams.keys;
        const query = {};
        for(var i = 0; i < keys.length; i++) {
            const key = keys[i];
            query[key] = queryParams.get(key);
        }
        return query;
    }
    ngOnInit() {
        this.subscription = this.route.queryParamMap.subscribe(queryParams => {
            const keys = queryParams.keys
            let query = this.getQueryObject(queryParams);
            if( this.route.snapshot.data.state == 'queue' ) {
                query = Object.assign({queue: true, user: this.user.id}, query);
            }
            if( this.route.snapshot.data.state == 'sentToEditor' ) {
                let queryExists = false;
                if(query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('sent_to_editor') || filter.value.includes('add_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'sent_to_editor|add_sent_to_editor', compare: '='}]}, query);
                }
            }
            if( this.route.snapshot.data.state == 'synSentToEditor' ) {
                let queryExists = false;
                if(query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('syn_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'syn_sent_to_editor', compare: '='}]}, query);
                }
            }
            if( this.route.snapshot.data.state == 'readyToRepost' ) {
                let queryExists = false;
                if(query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('ready_to_repost');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'ready_to_repost', compare: '='}]}, query);
                }
            }
            if( this.route.snapshot.data.state == 'readyToDeleteAppleNews' ) {
                let queryExists = false;
                if(query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('ready_to_delete_an');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'ready_to_delete_an', compare: '='}]}, query);
                }
            }
            if( this.route.snapshot.data.state == 'assigned' ) {
                let queryExists = false;
                if(query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('assigned');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'assigned', compare: '='}]}, query);
                }
            }
            this.assignmentService.userQuery = 0;
            if( query.user ) {
                this.assignmentService.userQuery = query.user;
            }
            if( query.view ) {
                this.vs.setCurrentView(query.view);
            } else {
                this.vs.setCurrentView(false);
            }         
        });
    }
    pageChange(event) {
        this.service.pageSize = event.pageSize;
        const queryParams = this.getQueryObject(this.route.snapshot.queryParamMap);
        let query = Object.assign({page: (event.pageIndex + 1), per_page: event.pageSize}, queryParams);
        if( this.route.snapshot.data.state == 'queue' ) {
            query = Object.assign({user: this.user.id, queue: true}, query);
        }
        if( this.route.snapshot.data.state == 'sentToEditor' ) {
            let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('sent_to_editor') || filter.value.includes('add_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
            if(!queryExists) {
                query = Object.assign({filters: [{key: 'status', value: 'sent_to_editor|add_sent_to_editor', compare: '='}]}, query);
            }
        }
        if( this.route.snapshot.data.state == 'synSentToEditor' ) {
            let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('syn_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
            if(!queryExists) {
                query = Object.assign({filters: [{key: 'status', value: 'syn_sent_to_editor', compare: '='}]}, query);
            }
        }
        if( this.route.snapshot.data.state == 'readyToRepost' ) {
            let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('ready_to_repost');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
            if(!queryExists) {
                query = Object.assign({filters: [{key: 'status', value: 'ready_to_repost', compare: '='}]}, query);
            }
        }
        if( this.route.snapshot.data.state == 'readyToDeleteAppleNews' ) {
            let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('ready_to_delete_an');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
            if(!queryExists) {
                query = Object.assign({filters: [{key: 'status', value: 'ready_to_delete_an', compare: '='}]}, query);
            }
        }
        if( this.route.snapshot.data.state == 'assigned' ) {
            let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('assigned');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'assigned', compare: '='}]}, query);
                }
        }
        let filterQuery = this.fs.query;
        if( filterQuery.filters.length > 0 ) {
            query = Object.assign(query, filterQuery);
        }
        this.service.loadAssignments(query);
    }
    inSelectedRows(item) {
        return this.getItemIndex(item) !== -1;
    }
    getItemIndex(item) {
        return this.selectedRows.reduce((out, el, i) => {
            if( el.id === item.id ) {
                out = i;
            }
            return out;
        }, -1);
    }
    selectRowChange(event, item, go) {
        let index = this.getItemIndex(item);
        if( event.checked && index === -1 ) {
            this.selectedRows.push(item);
        }
        if( !event.checked && index !== -1 ) {
            this.selectedRows.splice(index, 1);
        }
        if( go && this.selectedRows.length > 0 ) {
            this.assignmentService.delete(this.selectedRows);
        }
    }
    getAffiliates(item) {
        if( !item.affiliates ) {
            return [];
        }
        return item.affiliates.split(',');
    }
    getQuizType(item) {
        if( item.childType !== 'quiz' ) {
            return '';
        }
        return item.quizType === 'personality' ? 'Personality' : 'Standard';
    }
    getTerms(item, slug) {
        if( !item.taxonomies[slug] ) {
            return '';
        }
        return item.taxonomies[slug].map(item => item.name).join(', ');
    }
    getTaxTitle(taxonomies = {}) {
        const taxes = Object.keys(taxonomies);
        const apiTaxes = this.api.getProp('taxonomies');
        let title = [];
        for(var i = 0; i < taxes.length; i++) {
            const tax = taxes[i];
            const apiTax = apiTaxes[tax];
            if( apiTax ) {
                title.push(apiTax.name);
            }
        }
        return title.join(', ');
    }
    submitAssignment(assignment) {
        if( this.route.snapshot.data.state == 'readyToDeleteAppleNews' && assignment.status == 'ready_to_delete_an' ) {
            assignment.status = 'ready_to_repost';
            this.api.doAction('post', 'assignments', {
                action: 'update',
                assignment: assignment
            }).subscribe(data => {
                if (data && data.status === 'ready_to_repost') {
                    assignment = data;
                }
            });
        }
    }
    unSubmitAssignment(assignment) {
        if( this.route.snapshot.data.state == 'readyToRepost' && assignment.status == 'ready_to_repost' ) {
            assignment.status = 'ready_to_delete_an';
            this.api.doAction('post', 'assignments', {
                action: 'update',
                assignment: assignment
            }).subscribe(data => {
                if (data && data.status === 'ready_to_delete_an') {
                    assignment = data;
                }
            });
        }
    }
    retireAssignment(assignment) {
        if( this.route.snapshot.data.state == 'readyToDeleteAppleNews' && assignment.status == 'ready_to_delete_an' ) {
            assignment.status = 'syndication_retired';
            this.api.doAction('post', 'assignments', {
                action: 'update',
                assignment: assignment
            }).subscribe(data => {
                if (data && data.status === 'syndication_retired') {
                    assignment = data;
                }
            });
        }
    }
    unretireAssignment(assignment) {
        if( assignment.status == 'syndication_retired' ) {
            assignment.status = 'ready_to_delete_an';
            this.api.doAction('post', 'assignments', {
                action: 'update',
                assignment: assignment
            }).subscribe(data => {
                if (data && data.status === 'ready_to_delete_an') {
                    assignment = data;
                }
            });
        }
    }
    getCreatorTaxonomies(item) {
        if( !item.taxonomies || !item.taxonomies.creation ) {
            return [];
        }
        return item.taxonomies.creation.map(tax => tax.name);
    }
    getSiteCategories(item) {
        if( !item.sites || !item.sites.length ) {
            return [];
        }
        return item.sites.map(site => `${site.name}: ${site.categories?.map(cat => cat.name)?.join(', ')}` );
    }
    ngOnDestroy() {
        if( this.subscription ) {
            this.subscription.unsubscribe();
        }
        if( this.filterSubscription ) {
            this.filterSubscription.unsubscribe();
        }
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
}